import React, {useState, useEffect, useContext} from "react"
import {contact_server} from "../trialSteps/contact-server"
import CartContext from "../../contexts/CartContext"

let OrderValidatePrice = props=>{
    const {cart} = useContext(CartContext);

    const {
      nextStep,
      onError,
      setDatabaseData,  
      serverUrl,            
  } = props;
  let [contactingServer, setContactingServer] = useState(false)

    useEffect( ()=>{
      let total = cart.reduce((sum, item)=>sum+item.price, 0)
      let params = {
        orders: cart,
        user: "Customer Service",
        language: "English" ,
        total: 100 * total,
        // email: token['email'],
        // card: token['id'],
      }
      setDatabaseData(params)
      contact_server ({
        databaseData: params,
        setDatabaseData,
        nextStep,
        onError,
        url: `${serverUrl}/cart/order_validate_price`,
      });
      setContactingServer(true);
      // eslint-disable-next-line
    }, [])
    
  if (contactingServer)
    return <h2>Contacting Server...</h2>
  return <h2> Server contacted </h2>
}

export default OrderValidatePrice
